// Module
var code = "<div class=\"component-editor-multi-edges-transformation\">\n  <steps>\n    <step ng-model=\"componentOrderStep\"></step>\n    <step ng-model=\"componentFormStep\"></step>\n  </steps>\n</div>\n";
// Exports
module.exports = code;